import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import AYUDA from '../lib/ayuda.json';
import { irAlPanel } from '../lib/paneles';
import '../styles/Regalos.css';
import '../styles/Extras.css';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';

const normalizar = (t) => String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// Centro de ayuda: /ayuda es el índice y cada tema tiene su propio enlace /ayuda/<tema>.
// El asistente lleva directo al tema que corresponde.
export default function AyudaPage() {
  const { user } = useAuth();
  const { seccion } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const idx = AYUDA.secciones.findIndex(s => s.id === seccion);
  const actual = idx >= 0 ? AYUDA.secciones[idx] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = actual ? `${actual.titulo} · Ayuda · Cupido con Mate` : 'Ayuda · Cupido con Mate';
  }, [actual]);

  const nq = normalizar(q.trim());
  const lista = AYUDA.secciones.filter(s => !nq ||
    normalizar([s.titulo, ...s.pasos, s.tip || '', ...s.claves].join(' ')).includes(nq));

  return (
    <div className="regalos-page">
      {user ? <Navbar /> : (
        <div className="ayuda-top container">
          <button className="ayuda-marca" onClick={() => navigate('/')}>
            <img src={LOGO} srcSet={LOGO_SRCSET} sizes="36px" alt="" /> Cupido con Mate
          </button>
          <button className="btn btn-primary btn-sm" onClick={() => (seccion === 'comercios' ? irAlPanel('/comercio', navigate) : navigate('/auth'))}>Ingresar</button>
        </div>
      )}
      <div className="regalos-container container">
        {actual ? (
          <>
            <Link to="/ayuda" className="ayuda-volver">← Todos los temas de ayuda</Link>
            <section className="ayuda-seccion">
              <h1>{actual.icono} {actual.titulo}</h1>
              <ol>{actual.pasos.map((p, i) => <li key={i}>{p}</li>)}</ol>
              {actual.tip && <p className="ayuda-tip">💡 {actual.tip}</p>}
            </section>
            <div className="ayuda-nav">
              {idx > 0 ? <Link to={`/ayuda/${AYUDA.secciones[idx - 1].id}`}>← {AYUDA.secciones[idx - 1].titulo}</Link> : <span />}
              {idx < AYUDA.secciones.length - 1 && <Link to={`/ayuda/${AYUDA.secciones[idx + 1].id}`}>{AYUDA.secciones[idx + 1].titulo} →</Link>}
            </div>
            <p className="regalos-sub" style={{ marginTop: 24 }}>¿Te quedó alguna duda? Preguntale al asistente 🧉 (el botón redondo de abajo a la derecha).</p>
          </>
        ) : (
          <>
            <h1 className="regalos-title" style={{ marginBottom: 8 }}>❓ {AYUDA.titulo}</h1>
            <p className="regalos-sub" style={{ marginBottom: 16 }}>{AYUDA.intro}</p>
            {seccion && <p className="regalos-empty">No encontramos ese tema. Elegí uno de la lista.</p>}
            <input className="form-input ayuda-buscar" placeholder="Buscar: nota, descuentos, cita segura…" value={q} onChange={e => setQ(e.target.value)} />
            {lista.length === 0
              ? <p className="regalos-empty">No encontramos nada con «{q}». Probá con otra palabra o preguntale al asistente 🧉.</p>
              : (
                <ul className="ayuda-temas">
                  {lista.map(s => (
                    <li key={s.id}>
                      <Link to={`/ayuda/${s.id}`}>
                        <span className="ayuda-tema-icono">{s.icono}</span>
                        <span className="ayuda-tema-titulo">{s.titulo}</span>
                        <span className="ayuda-tema-flecha">›</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
          </>
        )}
      </div>
    </div>
  );
}
